'use client';

import React, { useState } from 'react';
import { cx } from 'cva';
import Typography from '../next-ui/Typography';

export default function ExpandableList({ items, className = '' }) {
  const [expanded, setExpanded] = useState(false);
  const visibleItems = expanded ? items : items.slice(0, 4);

  return (
    <div className="flex flex-col gap-6">
      {visibleItems.map((item, index) => (
        <div key={index}>{item}</div>
      ))}
      {items.length > 4 && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="flex w-full justify-end">
          <Typography
            variant="body2"
            color="textSecondary"
            className={cx('ml-2 bg-white hover:text-primary', className)}>
            {expanded ? '...see less' : '...see more'}
          </Typography>
        </button>
      )}
    </div>
  );
}
